import { ChevronLeft, ChevronRight } from "lucide-react";
import { L } from "@/i18n";

const cls = "flex items-center gap-1 rounded-md border border-slate-700 px-3 py-1.5 text-xs text-slate-300 disabled:opacity-40 hover:border-amber-500/50 hover:text-amber-400 transition-colors";

export const QuestionsPager = ({ page, pages, hasNext, onPage }) => (
  <div className="flex items-center justify-between gap-4 pt-2 text-xs text-slate-400" data-testid="questions-pager">
    <button disabled={page <= 1} onClick={() => onPage(page - 1)} className={cls} data-testid="questions-prev-page">
      <ChevronLeft className="h-4 w-4" /> {L("Previous", "Anterior")}
    </button>
    <span className="font-mono" data-testid="questions-page-indicator">{L("Page", "Página")} {page}{pages ? ` / ${pages}` : ""}</span>
    <button disabled={!hasNext} onClick={() => onPage(page + 1)} className={cls} data-testid="questions-next-page">
      {L("Next", "Seguinte")} <ChevronRight className="h-4 w-4" />
    </button>
  </div>
);
